const largeText = {
    fontSize: 25
}
export default largeText;
